import React from "react";
import { Pane, Heading } from "evergreen-ui";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import {
  getDateObject,
  disabledDate,
  checkIfDateIsAfter,
  checkIfDateIsBefore,
} from "../util";
import moment from "moment";

const DateRangePicker = (props) => {
  const {
    fromDate,
    toDate,
    currentDate,
    dateChange,
    paddingLeft,
    paddingRight,
    disableFutureDates,
  } = props;

  function hideKeyboard() {
    //this set timeout needed for case when hideKeyborad
    //is called inside of 'onfocus' event handler
    setTimeout(function () {
      //creating temp field
      var field = document.createElement("input");
      field.setAttribute("type", "text");
      //hiding temp field from peoples eyes
      //-webkit-user-modify is nessesary for Android 4.x
      field.setAttribute(
        "style",
        "position:absolute; top: 0px; opacity: 0; -webkit-user-modify: read-write-plaintext-only; left:0px;"
      );
      document.body.appendChild(field);

      //adding onfocus event handler for out temp field
      field.onfocus = function () {
        //this timeout of 200ms is nessasary for Android 2.3.x
        setTimeout(function () {
          field.setAttribute("style", "display:none;");
          setTimeout(function () {
            document.body.removeChild(field);
            document.body.focus();
          }, 14);
        }, 200);
      };
      //focusing it
      field.focus();
    }, 50);
  }

  const fromDateChange = (date) => {
    let { toDate } = props;
    const dateObject = getDateObject(date, "DD - MMM - YY");
    const toDateObject = getDateObject(toDate);
    if (checkIfDateIsAfter(dateObject, toDateObject)) {
      toDate = dateObject;
    }
    dateChange({
      fromDate: getDateObject(date, "DD - MMM - YY").format("YYYY-MM-DD"),
      toDate: getDateObject(toDate).format("YYYY-MM-DD"),
    });
  };

  const toDateChange = (date) => {
    let { fromDate } = props;
    const dateObject = getDateObject(date, "DD - MMM - YY");
    const fromDateObject = getDateObject(fromDate);
    if (checkIfDateIsBefore(dateObject, fromDateObject)) {
      fromDate = dateObject;
    }
    dateChange({
      toDate: dateObject.format("YYYY-MM-DD"),
      fromDate: getDateObject(fromDate).format("YYYY-MM-DD"),
    });
  };

  return (
    <Pane
      display={"flex"}
      justifyContent={"space-between"}
      paddingLeft={paddingLeft}
      paddingRight={paddingRight}
    >
      <Pane
        marginRight={10}
        display={"flex"}
        flexDirection={"column"}
        width={"50%"}
      >
        <Heading marginBottom={4} size={400} color={"#425A70"}>
          From
        </Heading>
        <DatePicker
          className={"date-picker"}
          defaultValue={currentDate}
          value={getDateObject(fromDate)}
          format={"DD - MMM - YY"}
          onOpenChange={(e) => {
            console.log("test");
          }}
          onFocus={(e) => {
            document.querySelector(".date-picker input").ariaReadOnly = true;
          }}
          inputReadOnly="false"
          disabledDate={disableFutureDates && disabledDate}
          onChange={(e) => {
            document.querySelector(".date-picker input").blur();
            fromDateChange(e.format("DD - MMM - YY"));
          }}
        />
      </Pane>
      <Pane
        marginLeft={10}
        display={"flex"}
        flexDirection={"column"}
        width={"50%"}
      >
        <Heading marginBottom={4} size={400} color={"#425A70"}>
          To
        </Heading>
        <DatePicker
          className={"date-picker"}
          defaultValue={currentDate}
          value={getDateObject(toDate)}
          format={"DD - MMM - YY"}
          // disabledDate={disableFutureDates && disabledDate}
          onChange={(e) => {
            document.querySelector(".date-picker input").blur();
            toDateChange(e.format("DD - MMM - YY"));
          }}
          inputReadOnly="false"
        />
      </Pane>
    </Pane>
  );
};

export default DateRangePicker;
